import { render, staticRenderFns } from "./SimpleEmpty.vue?vue&type=template&id=3c102b23&scoped=true"
import script from "./SimpleEmpty.vue?vue&type=script&lang=js"
export * from "./SimpleEmpty.vue?vue&type=script&lang=js"
import style0 from "./SimpleEmpty.vue?vue&type=style&index=0&id=3c102b23&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c102b23",
  null
  
)

export default component.exports